const SearchPage = () => {
  // return <SearchResult />;
  return null;
};

export default SearchPage;
